import { render, staticRenderFns } from "./AddCoinFavBtn.vue?vue&type=template&id=362eafc2&"
import script from "./AddCoinFavBtn.vue?vue&type=script&lang=js&"
export * from "./AddCoinFavBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddCoinFavBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports